import React, { useEffect, useState } from "react";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import ActivityJobTrigger from "../../StateMachine/JobTrigger/ActivityJobTrigger";
import { useEntityContext } from "../../../context/EntityContext";

const EntityJobs = () => {
  const [allJobs, setAllJobs] = useState({});

  const { entityInitData, selectedEntitySm, setEntityInitData, smTriggerJobData, setSmTriggerJobData } =
    useEntityContext();

  useEffect(() => {
    const fetchAllTemplatesAndJobs = async () => {
      try {
        const [{ data: postJobData }, { data: preJobData }, { data: preSubmissionJobData }, { data: smTriggerData }] =
          await Promise.all([
            axiosInstance.get(`/jobs/filter?places=post_activity`),
            axiosInstance.get(`/jobs/filter?places=pre_activity`),
            axiosInstance.get(`/jobs/filter?places=pre_submission`),
            axiosInstance.get(`/jobs/filter?places=sm_job`)
          ]);

        setAllJobs({
          post_activity: postJobData,
          pre_activity: preJobData,
          pre_submission: preSubmissionJobData,
          sm_trigger_job: smTriggerData
        });
      } catch (error) {
        handleApiError(error);
      }
    };

    fetchAllTemplatesAndJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePreActivityData = (jobs) => {
    const newEntityInitData = JSON.parse(JSON.stringify(entityInitData));
    newEntityInitData.pre_activity_job = jobs;
    setEntityInitData(newEntityInitData);
  };

  const settingPreSubmission = (jobs) => {
    const newEntityInitData = JSON.parse(JSON.stringify(entityInitData));
    newEntityInitData.pre_submission = jobs;
    setEntityInitData(newEntityInitData);
  };

  const handleSmJobTrigger = (jobs) => {
    setSmTriggerJobData(jobs);
  };

  const setJobTriggerFormula = (data) => {
    const newEntityInitData = JSON.parse(JSON.stringify(entityInitData));
    newEntityInitData.jobs_trigger_formula = data;
    setEntityInitData(newEntityInitData);
  };

  const handleJobTriggerData = (jobs) => {
    const newEntityInitData = JSON.parse(JSON.stringify(entityInitData));
    newEntityInitData.jobs_trigger = jobs;
    setEntityInitData(newEntityInitData);
  };

  return (
    <div className="activity-main-screen">
      <div className=" entity-job-items">
        <div className="activity_job_trigger">
          <ActivityJobTrigger
            jobTriggerData={entityInitData.pre_activity_job}
            setJobTriggerData={handlePreActivityData}
            stateid={selectedEntitySm.stateid}
            allJobs={allJobs.pre_activity || []}
            actId={selectedEntitySm.id}
            pageType="entity"
            jobType="pre"
          />
          <ActivityJobTrigger
            jobTriggerData={entityInitData.pre_submission}
            setJobTriggerData={settingPreSubmission}
            stateid={selectedEntitySm.stateid}
            actId={selectedEntitySm.id}
            allJobs={allJobs.pre_submission || []}
            pageType="entity"
            jobType="pre_submission"
          />
          <ActivityJobTrigger
            jobTriggerFormula={entityInitData.jobs_trigger_formula}
            setJobTriggerFormula={setJobTriggerFormula}
            jobTriggerData={entityInitData.jobs_trigger}
            setJobTriggerData={handleJobTriggerData}
            stateid={selectedEntitySm.stateid}
            allJobs={allJobs.post_activity || []}
            actId={selectedEntitySm.id}
            pageType="entity"
            jobType="post"
          />
          <ActivityJobTrigger
            jobTriggerData={smTriggerJobData || []}
            setJobTriggerData={handleSmJobTrigger}
            stateid={selectedEntitySm.stateid}
            allJobs={allJobs.sm_trigger_job || []}
            actId={selectedEntitySm.id}
            pageType="entity"
            jobType="sm_trigger_job"
            isSmJob={true}
          />
        </div>
      </div>
    </div>
  );
};

export default EntityJobs;
